var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"el-backtop",style:({
    right: _vm.styleRight,
    bottom: _vm.styleBottom,
    position: 'fixed'
  }),on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_vm._t("default",function(){return [_c('van-icon',{staticClass:"van-badge__wrapper van-icon van-icon-back-top van-back-top__icon"})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }